import { useContext } from 'react';
import HeaderBarContext from '../contexts/header-bar';

const useHeaderBar = () => {
  const value = useContext(HeaderBarContext);

  return value;
};
    
export default useHeaderBar;